import React from 'react';
import ErrorMessage from './ErrorMessage';
import useLocalize from '../utils/hooks/useLocalize';
import { closeForm } from '../utils/dataProcessing';

const NotFound = () => {
  const { localize } = useLocalize();
  return (
    <ErrorMessage error={localize('error.noTutorial')} close={closeForm} />
  );
};

export default NotFound;
